/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Hide_Scheduled_Trips_DescriptionInputs */

const fr_settings_hide_scheduled_trips_description = /** @type {(inputs: Settings_Hide_Scheduled_Trips_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer les courses pour lesquelles aucun temps réel n'est disponible.`)
};

const en_settings_hide_scheduled_trips_description = /** @type {(inputs: Settings_Hide_Scheduled_Trips_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide trips for which no real-time data is available.`)
};

/**
* | output |
* | --- |
* | "Hide trips for which no real-time data is available." |
*
* @param {Settings_Hide_Scheduled_Trips_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_hide_scheduled_trips_description = /** @type {((inputs?: Settings_Hide_Scheduled_Trips_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Hide_Scheduled_Trips_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_hide_scheduled_trips_description(inputs)
	return en_settings_hide_scheduled_trips_description(inputs)
});